function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Segment_svg__41_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F4F9FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#F8E7FF"
})), React.createElement("linearGradient", {
  id: "Segment_svg__42_b",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#8E9DFE",
  stopOpacity: 0.2
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#B97AD3",
  stopOpacity: 0.2
})), React.createElement("linearGradient", {
  id: "Segment_svg__43_c",
  x1: "86.735%",
  x2: "13.265%",
  y1: "100%",
  y2: "0%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#637EFF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#C363E5"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#Segment_svg__41_a)",
  stroke: "url(#Segment_svg__42_b)",
  strokeWidth: 1.111,
  d: "M6.4.556A5.844 5.844 0 00.556 6.4v27.2A5.844 5.844 0 006.4 39.444h27.2a5.844 5.844 0 005.844-5.844V6.4A5.844 5.844 0 0033.6.556H6.4z"
}), React.createElement("path", {
  fill: "url(#Segment_svg__43_c)",
  d: "M15 13.333c.92 0 1.667.747 1.667 1.667v1.111c0 .92-.747 1.667-1.667 1.667H5c-.92 0-1.667-.746-1.667-1.667V15c0-.92.747-1.667 1.667-1.667h10zm-2.222 1.111H6.11a.556.556 0 000 1.112h6.667a.556.556 0 000-1.112zM15 2.222c.92 0 1.667.746 1.667 1.667v5.555c0 .92-.747 1.667-1.667 1.667H5c-.92 0-1.667-.746-1.667-1.667V3.89c0-.92.747-1.667 1.667-1.667h10zm-4.444 4.445H6.11a.556.556 0 100 1.11h4.445a.556.556 0 000-1.11zm3.333-2.223H6.11a.556.556 0 000 1.112h7.778a.556.556 0 000-1.112z",
  transform: "translate(10 10)"
}));

var SvgSegment = function SvgSegment(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
};

export default SvgSegment;